import { initialPagination, initialState, makeListEffects, makeListReducers } from '@/models/utils';
import { filtersConfig } from './utils';

const namespace = 'delegations';

const DelegationsModel = {
  namespace,
  state: {
    ...initialState,
    filtersConfig,
  },
  effects: makeListEffects({
    namespace,
    fetchRoute: 'delegation',
    fetchParams: 'delegations',
  }),
  reducers: makeListReducers({
    initialPagination,
    initialState: {
      ...initialState,
      filtersConfig,
    },
  }),
};

export default DelegationsModel;
